import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react';
import { useContext, useRef, useMemo } from 'react';
import { LayoutGroupContext } from '../../context/LayoutGroupContext.mjs';
import { DeprecatedLayoutGroupContext } from '../../context/DeprecatedLayoutGroupContext.mjs';
import { useForceUpdate } from '../../utils/use-force-update.mjs';
import { nodeGroup } from '../../projection/node/group.mjs';

var shouldInheritGroup = function shouldInheritGroup(inherit) {
  return inherit === true;
};

var shouldInheritId = function shouldInheritId(inherit) {
  return shouldInheritGroup(inherit === true) || inherit === "id";
};

var LayoutGroup = function LayoutGroup(_ref) {
  var children = _ref.children,
      id = _ref.id,
      _ref$inherit = _ref.inherit,
      inherit = _ref$inherit === void 0 ? true : _ref$inherit;
  var layoutGroupContext = useContext(LayoutGroupContext);
  var deprecatedLayoutGroupContext = useContext(DeprecatedLayoutGroupContext);

  var _useForceUpdate = useForceUpdate(),
      _useForceUpdate2 = _slicedToArray(_useForceUpdate, 2),
      forceRender = _useForceUpdate2[0],
      key = _useForceUpdate2[1];

  var context = useRef(null);
  var upstreamId = layoutGroupContext.id || deprecatedLayoutGroupContext;

  if (context.current === null) {
    if (shouldInheritId(inherit) && upstreamId) {
      id = id ? upstreamId + "-" + id : upstreamId;
    }

    context.current = {
      id: id,
      group: shouldInheritGroup(inherit) ? layoutGroupContext.group || nodeGroup() : nodeGroup()
    };
  }

  var memoizedContext = useMemo(function () {
    return _objectSpread(_objectSpread({}, context.current), {}, {
      forceRender: forceRender
    });
  }, [key]);
  return React.createElement(LayoutGroupContext.Provider, {
    value: memoizedContext
  }, children);
};

export { LayoutGroup };